import React from 'react';
import FormField from '../FormField'; // Upewnij się, że ścieżka do pliku jest poprawna
import { accommodationTypes } from '../../../data/Constants';
import "../../../css/AddTripForm/Element.css";
const AccommodationElement = ({ data, handleChange }) => {
  const handleIsWithLimitedPlaces = async (field, value) => {
    if (value === false)
    {
      handleChange('capacity', null);
    }
    handleChange(field, value);
  }

  const isLinked = data.variants.length > 1;
  return (
    <div>

      <FormField
        label="Nazwa"
        name="name"
        value={data.name || ''}
        onChange={(name, value) => handleChange(name, value)}
        placeholder="Podaj nazwę noclegu"
        required
      />
      <FormField
        label="Opis"
        name="description"
        type="richtext"
        value={data.description || ''}
        onChange={(name, value) => handleChange(name, value)}
        placeholder="Aby użyć link wpisz dowolny tekst (np. Klik) a następnie go zaznacz i wybierz ostatni symbol z paska narzędzi. To pozwoli Ci wpisać link."
        info={`Opisz, w miarę możliwości:
           ● warunki - liczba osób w pokoju, materace, toalety, prysznic, bieżąca woda; 
           ● pościel  - czy jest wliczona w cenę / ile kosztuje; 
           ● ręczniki, śpiwory - czy trzeba zabrać swój; 
           ● dostęp do prądu / możliwość ładowania telefonu.`}
      />
      <FormField
        label="Czas rozpoczęcia"
        name="startDate"
        type="datetime-local"
        value={data.startDate || ''}
        onChange={(name, value) => handleChange(name, value)}
        required
      />
      <FormField
        label="Czy z limitem miejsc?"
        name="isWithLimitedPlaces"
        type="toggle"
        value={data.isWithLimitedPlaces}
        onChange={(name, value) => handleIsWithLimitedPlaces(name, value)}
      />

    {data.isWithLimitedPlaces && (
      <FormField
        label="Limit miejsc"
        name="capacity"
        type="number"
        min="1"
        step="1"
        value={data.capacity?.toString() || ""}
        onChange={(field, value) => handleChange(field, value)}
        required={data.isWithLimitedPlaces}
      />
    )}
  <FormField
        label="Typ obiektu"
        name="accommodationType"
        type="select"
        value={data.accommodationType || 0}
        onChange={handleChange}
        options={accommodationTypes}
        info="Kategoryzacja obiektu noclegowego według ustawy - kategorię obiektu można sprawdzić na stronach Urzędu Marszałkowskiego województwa, w którym znajduje się obiekt. Jeśli nie znajdziemy go w rejestrze, należy wybrać “inny obiekt”"
  />
    <FormField
        label="Wyżywienie"
        name="accommodationBoard"
        type="text"
        value={data.accommodationBoard || ""}
        onChange={(field, value) => handleChange(field, value)}
  />
    <FormField
    label="Link"
    name="link"
    type="text"
    value={data.link || ''}
    onChange={(field, value) => handleChange(field, value)}
    placeholder="Podaj link do noclegu"
  />

      <FormField
        label="Ustalona cena (brutto) na osobę"
        info="Pamiętaj o uwzględnieniu buforu (10% oryginalnego kosztu, nie mniej niż 6 zł) i ewentualnym pokryciu kosztów osoby koordynatorskiej"
        name="pricePerPerson"
        type="number"
        value={data.pricePerPerson?.toString() || ''}
        onChange={handleChange}
        placeholder="Podaj cenę"
        step="0.01"
        min="0"
        unit="zł"
      />

      <FormField
        label="Kwota z faktury"
        name="invoiceAmount"
        type="number"
        value={data.invoiceAmount?.toString() || ''}
        onChange={handleChange}
        placeholder="Podaj kwotę z faktury"
        step="0.01"
        min="0"
        unit="zł"
        info="Prognozowana kwota z faktury. Widoczna tylko w widoku Zestawienia. Nie jest wyświetlana na formularzu zapisów."
      />

       <FormField
        label="Komentarz (do rozliczeń)"
        name="internalComment"
        type="textarea"
        value={data.internalComment || ''}
        onChange={handleChange}
        placeholder="Komentarz dla osoby koordynatorskiej"
        info="Widoczny tylko w widoku Zestawienia. Nie jest wyświetlany na formularzu zapisów."
      />
    </div>
  );
};

export default AccommodationElement;
